<template>
	<div class="dragDropTop" v-if="valueCopy">
		<el-card>
			<div class="class_item">
				<span class="label">维度：</span>
				<draggable
					v-model="valueCopy.indexDTO.dimensionList"
					class="draggable_body"
					v-if="valueCopy.indexDTO"
					chosen-class="chosen"
					force-fallback="true"
					filter=".noDrag"
					:move="onMove"
					@end="orderChange"
					animation="500"
				>
					<transition-group>
						<el-tag
							v-for="(item, index) in valueCopy.indexDTO.dimensionList"
							:class="index == 0 ? 'drag_item noDrag' : 'drag_item'"
							:closable="!index == 0"
							:key="item"
							@close="deselect(index, true)"
						>
							<span>
								<img
									src="@/assets/googleAds/tuodong.png"
									class="tuodong"
									alt=""
									v-if="!index == 0"
								/>
								<span>{{ setShowObj(item, true).label }}</span>
							</span>
						</el-tag>
					</transition-group>
				</draggable>
			</div>
			<div
				class="class_item"
				v-if="
					valueCopy.indexDTO.indexList.length !== 0 &&
					reportConfiguration[valueCopy.type - 1].indicators.length !== 0
				"
			>
				<span class="label">指标：</span>
				<draggable
					v-model="valueCopy.indexDTO.indexList"
					class="draggable_body"
					chosen-class="chosen"
					v-if="valueCopy.indexDTO"
					force-fallback="true"
					animation="500"
					filter=".noDrag"
					:move="onIndexMove"
					@end="orderChange"
				>
					<transition-group>
						<el-tag
							v-for="(item, index) in valueCopy.indexDTO.indexList"
							:class="setShowObj(item).noDrag ? 'drag_item noDrag' : 'drag_item'"
							:closable="true"
							:key="item"
							@close="deselect(index)"
						>
							<span>
								<img
									src="@/assets/googleAds/tuodong.png"
									class="tuodong"
									alt=""
									v-if="!setShowObj(item).noDrag"
								/>
								<span>{{ setShowObj(item).label }}</span>
							</span>
						</el-tag>
					</transition-group>
				</draggable>
			</div>
			<div class="class_item screenBody" v-if="reportConfiguration[valueCopy.type - 1].screen">
				<span class="label">筛选：</span>
				<div class="screenItem">
					<skySelect
						v-for="item in reportConfiguration[valueCopy.type - 1].screen"
						v-model="valueCopy.indexDTO.chooseMap[item.key]"
						:key="item.key"
						:multiple="true"
						:collapse-tags="true"
						@change="change"
						:options="item.options"
					>
						<slot slot="prefix">
							<div>{{ item.label }}</div>
						</slot>
					</skySelect>
				</div>
			</div>
			<div class="sort_body" v-if="reportConfiguration[valueCopy.type - 1].isSort">
				<el-divider></el-divider>
				<div class="class_item">
					<span class="label">排序：</span>
					<skydropdown-select
						:options="sortOptions"
						v-model="valueCopy.indexDTO.orderWay"
						@change="change"
					></skydropdown-select>
					<skydropdown-select
						:options="indicatorsSortOptions"
						v-model="valueCopy.indexDTO.orderList[0]"
						@change="change"
					></skydropdown-select>
				</div>
			</div>
		</el-card>

		<div class="falf_body">
			<el-checkbox v-model="valueCopy.falgSummaryRow" @change="change">添加汇总行</el-checkbox>
			<el-button type="primary" @click="showPreview">预览</el-button>
		</div>

		<!-- 报告预览 -->
		<reportPreview ref="reportPreview" dialogWidth="900px" title="报告预览" />
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import skySelect from '@/components/iglobalwin/formComponents/sky-select';
import reportPreview from './form/reportPreview';
import reportConfiguration from './js/reportConfiguration';

export default {
	name: 'dragDropTop',
	props: ['value'],
	components: {
		draggable,
		skydropdownSelect,
		reportPreview,
		skySelect,
	},
	data() {
		return {
			valueCopy: null,
			isSort: false,
			sortOptions: [
				{
					value: 'desc',
					label: '降序',
				},
				{
					value: 'asc',
					label: '升序',
				},
			],
			reportConfiguration,
			previewDataIsStor: {},
		};
	},
	computed: {
		indicatorsSortOptions(self) {
			let { valueCopy } = self;
			let list = valueCopy.indexDTO.indexList.map(item => {
				let obj = reportConfiguration[this.valueCopy.type - 1].indicators.find(_item => {
					return _item.value === item;
				});
				return obj;
			});
			valueCopy.indexDTO.dimensionList.forEach(item => {
				let obj = reportConfiguration[this.valueCopy.type - 1].dimension.find(_item => {
					return _item.value === item;
				});
				if (obj.isSort) list.unshift(obj);
			});

			return list;
		},
	},
	watch: {
		value: {
			handler(val) {
				this.valueCopy = _.cloneDeep(val);
			},
			deep: true,
		},
	},
	methods: {
		// 禁止第一维度移动
		onMove(e) {
			if (e.relatedContext.index == 0) return false;
			return true;
		},
		// 禁止第一指标移动
		onIndexMove(e) {
			let { relatedContext } = e;
			let { element } = relatedContext;
			let obj = this.setShowObj(element);

			if (obj.noDrag) return false;
			return true;
		},
		// 数据顺序变化
		orderChange() {
			this.$emit('input', this.valueCopy);
		},
		// 数据变化
		change() {
			this.orderChange();
			this.$emit('preview');
		},
		// 获取显示项
		setShowObj(val, type) {
			return reportConfiguration[this.valueCopy.type - 1][type ? 'dimension' : 'indicators'].find(
				item => {
					return item.value === val;
				}
			);
		},
		// 取消选择
		deselect(index, type) {
			let { valueCopy } = this;
			valueCopy.indexDTO[type ? 'dimensionList' : 'indexList'].splice(index, 1);
			if (!valueCopy.indexDTO.indexList.includes(valueCopy.indexDTO.orderList[0])) {
				this.valueCopy.indexDTO.orderList[0] = valueCopy.indexDTO.indexList[0];
			}
			this.orderChange();
		},
		// 预览弹窗显示
		async showPreview() {
			let data = await this.$refs.reportPreview.show(this.previewDataIsStor);
			let { cancel } = data;
			if (!cancel) {
				this.previewDataIsStor = data;
				this.$emit('preview', _.cloneDeep(data));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.dragDropTop {
	width: 100%;

	.class_item {
		display: flex;
		align-items: center;
		margin: 10px 0;
		min-height: 37px;

		.draggable_body {
			width: 0;
			flex: 1;
		}

		.label {
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
		}

		.el-dropdown {
			margin-right: 20px;
		}

		.toolFormItem {
			width: auto;
			margin-right: 20px;
		}
	}

	.screenBody {
		.screenItem {
			// display: flex;
			width: 0;
			flex: 1;

			.toolFormItem {
				display: inline-block;
				width: 296px;
				margin-bottom: 5px;
			}
			::v-deep .el-select {
				.el-select__tags {
					width: 159px !important;
					left: 100px;

					input {
						margin-left: 5px !important;
					}
				}

				.el-input {
					input {
						padding-left: 105px;
					}

					.el-input__prefix {
						left: 0;
						font-size: 12px;
						display: flex;
						justify-content: center;
						align-items: center;
						border: 1px solid #e8e8e8;
						padding: 0 10px;
						background-color: #f5f7fa;
						color: #909399;
						border-radius: 4px;

						div {
							width: 75px;
						}
					}
				}
			}
		}
	}

	.el-divider {
		margin: 10px 0;
	}
	.drag_item {
		margin-right: 10px;
		cursor: move;
		margin-top: 5px;

		.iconfont {
			margin-right: 10px;
		}
	}

	.falf_body {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;
		padding: 0 10px;
	}

	.tuodong {
		width: 8px;
		height: 14px;
		margin-right: 10px;
		top: 2px;
		position: relative;
	}
}
</style>
